import Button from '@mui/material/Button';
import { hexWithOpacity, toTitleCase } from 'common/utils';
import { colors } from 'styles/colors';
import useStyles from './styles';
import Circle from 'components/common/Circle/Circle';
import CustomText from 'components/common/CustomText/CustomText';
import { EOrderStatus } from 'enum/EOrderStatus';

interface Props {
  status: EOrderStatus;
}

export default function OrderStatus({ status }: Props) {
  const styles = useStyles();

  const getStatusColor = (useStatus: EOrderStatus) => {
    switch (useStatus) {
      case EOrderStatus.ON_HOLD:
        return colors.error;
      case EOrderStatus.PENDING:
        return colors.pending;
      case EOrderStatus.PREPARING:
        return colors.preparing;
      case EOrderStatus.IN_DELIVERY:
        return colors.shipped;
      case EOrderStatus.PARTIALLY_DELIVERED:
        return colors.success;
      case EOrderStatus.DELIVERED:
        return colors.success;
      case EOrderStatus.PARTIALLY_RETURNED:
        return colors.returned;
      case EOrderStatus.RETURNED:
        return colors.returned;
      case EOrderStatus.CANCELLED:
        return colors.cancelled;
      default:
        return colors.text;
    }
  }

  return (
    <div>
      <Button
        className={styles.statusOuterButton}
        sx={{
          paddingLeft: 0,
          backgroundColor: hexWithOpacity(getStatusColor(status), 0.1),
          color: getStatusColor(status),
          '&&:hover': {
            bgcolor: hexWithOpacity(getStatusColor(status), 0.3),
            color: getStatusColor(status),
          },
        }}
      >
        <Circle
          boxSize={20}
          circleSize={6}
          color={getStatusColor(status)}
        />
        <CustomText text={toTitleCase(status)} color={getStatusColor(status)} fontSize={14} />
      </Button>
    </div>
  );
}
